export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["TOOL_CALLS_REQUESTED"] = "TOOL_CALLS_REQUESTED";
    Type["TOOLS_CALLED"] = "TOOLS_CALLED";
    Type["INVOCATION_FINISHED"] = "INVOCATION_FINISHED";
    Type["INVOCATION_CANCELED"] = "INVOCATION_CANCELED";
    Type["INVOCATION_FAILED"] = "INVOCATION_FAILED";
    Type["TIMED_OUT"] = "TIMED_OUT";
})(Type || (Type = {}));
export var ToolCallStatus;
(function (ToolCallStatus) {
    ToolCallStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    ToolCallStatus["SUCCESS"] = "SUCCESS";
    ToolCallStatus["ERROR"] = "ERROR";
    ToolCallStatus["REJECTED"] = "REJECTED";
})(ToolCallStatus || (ToolCallStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map